import type { FC } from 'react';
import { useGetEnterpriseRiskById } from 'src/hooks/queries/enterprise-risk/useGetEnterpriseRiskById';

type Props = {
  id: string | undefined;
};

const Breadcrumb: FC<Props> = ({ id }) => {
  if (!id) {
    throw new Error('Missing id param');
  }
  const { data } = useGetEnterpriseRiskById(id);

  return <>{data?.enterprise_risk?.[0]?.Title || ''}</>;
};

export default Breadcrumb;
